/* @flow */
import React, { useContext, useState, useCallback, useEffect } from "react";
import styled, { css } from "styled-components";
import { TourContext } from "./Tour";
import Protection from "./Protection";

// <Layout>
// +-----------------------------------+
// |             <Header/>             |
// +----------------------+------------+
// |                      |            |
// |                      |            |
// |      <Content/>      | <Sidebar/> |
// |                      |            |
// |                      |            |
// +----------------------+------------+
// </Layout>

const LayoutView = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: ${props =>
    props.theme.main}; /* TODO: убрать, цветам тут не место */
  font-family: Roboto, Arial, Sans-Serif;
  user-select: none;

  ${({ tour }) =>
    tour != null &&
    css`
      filter: blur(2px);
    `};
`;

export const Header = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
`;

export const Content = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  will-change: transform;
`;

export const Sidebar = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 2;
`;

type LayoutProps = {
  headerHeight: number,
  sidebarWidth: number,
  children: React.ChildrenArray<*>
};

function OrderSensitiveDesktopLayout(props: LayoutProps) {
  const [header, toolbar, controls, chart, news] = props.children;
  let tour = useContext(TourContext);

  const [showChart, setShowChart] = useState(true);

  const handleVisibilityChange = useCallback(() => {
    if (document.hidden) {
      setShowChart(false);
    } else {
      setShowChart(true);
    }
  }, []);

  useEffect(() => {
    if ( document.hidden !== undefined ) {
      document.addEventListener( "visibilitychange", handleVisibilityChange, false );
      return () => {
        document.removeEventListener( "visibilitychange", handleVisibilityChange, false );
      }
    }
  });

  return (
    <LayoutView tour={tour}>
      <Header style={{ height: props.headerHeight }}>
        {header}
        {toolbar}
      </Header>
      <Sidebar
        style={{
          top: props.headerHeight - 53,
          width: props.sidebarWidth
        }}
      >
        {controls}
      </Sidebar>
      <Content
        style={{
          top: props.headerHeight + 30,
          right: props.sidebarWidth
        }}
      >
        {showChart && chart}
        {news}
      </Content>
      <Protection
        dealsToCompensate={props.dealsToCompensate}
        onCompensation={props.onCompensation}
        compensationUpdated={props.compensationUpdated}
        compensationCreated={props.compensationCreated}
        onCompensationCreated={props.onCompensationCreated}
        isDesktop={true}
        activeAccount={props.activeAccount}
      />
    </LayoutView>
  );
}

export default OrderSensitiveDesktopLayout;



// WEBPACK FOOTER //
// ./src/components/TradeDesktopLayout.js